import React, { useState, useRef } from 'react';
interface TooltipProps {
  content: string;
  shortcut?: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom';
  align?: 'center' | 'end';
}
export function Tooltip({
  content,
  shortcut,
  children,
  position = 'top',
  align = 'center'
}: TooltipProps) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const show = () => {
    timerRef.current = setTimeout(() => setVisible(true), 400);
  };
  const hide = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setVisible(false);
  };
  const positionClass = position === 'top' ? 'bottom-full mb-2' : 'top-full mt-2';
  const alignClass = align === 'end' ? 'right-0' : 'left-1/2 -translate-x-1/2';
  return <div className="relative inline-flex" onMouseEnter={show} onMouseLeave={hide} data-id="element-430" data-mp="2ac80wp67a5x5">
      {children}
      {visible && <div className={`absolute z-[100] pointer-events-none whitespace-nowrap px-2.5 py-1.5 rounded-lg bg-[#0A1520] border border-navy-lighter shadow-xl text-xs text-gray-300 flex items-center gap-2 ${positionClass} ${alignClass}`} style={{
      animation: 'tooltipFadeIn 150ms ease-out'
    }} data-id="element-431" data-mp="2f9q92dce8h43">
          {content}
          {shortcut && <kbd className="px-1.5 py-0.5 rounded bg-navy-lighter text-gray-400 text-[10px] font-mono font-medium border border-navy-lighter/50" data-id="element-432" data-mp="qyilq1d3531t">
              {shortcut}
            </kbd>}
        </div>}
    </div>;
}